import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  Signal,
  Output,
  AfterViewInit,
  Renderer2,
  ElementRef, ViewChild
} from '@angular/core';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { RetailerProfileService } from 'src/app/services/retailer-profile/retailer-profile.service';
import { ActivatedRoute } from '@angular/router';
import {Meta} from '@angular/platform-browser'
import { RetailerProfileInterface } from '../dashboard/dashboard.interface';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { CrumbtrailService } from 'src/app/services/crumbtrail/crumbtrail.service';
import { ProfilesModule } from "../profiles.module";
import {environment} from "../../../environments/environment";
import {RxAuthService} from "../../services/rx-auth/rx-auth.service";
/* /import { RetailerProfileComponent, ProfilesModule_1 as ProfilesModule } from "../retailer-profile/retailer-profile.component"; */


@Component({
  selector: 'app-profile-wrapper',
  templateUrl: './profile-wrapper.component.html',
  styleUrls: ['./profile-wrapper.component.scss'],
})

export class ProfileWrapperComponent implements OnInit, AfterViewInit{

  constructor(
    private retService:RetailerProfileService,
    private route:ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    private meta:Meta,
    public crumbtrailService:CrumbtrailService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ){

  }

  showdata:boolean = true;
  profile:any = '';
  profileType:string = ''
  isBrowser:boolean = false
  isIframe:boolean = false

  public profileSignal: Signal<RetailerProfileInterface> = toSignal(this.route.data.pipe(map(({profileData}) => profileData)));

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId)
    //console.log('platform browser: ', this.isBrowser)
    if (this.isBrowser) {
      //console.log('Browser side: ')
    this.setProfile()

    } else {
      //console.log('Server side:')
     this.setMetaTags()
    }


  }
  ngAfterViewInit() {
    try {
      this.isIframe = window.self !== window.top;
    } catch (e) {
      this.isIframe = true;
    }
  }

  setMetaTags() {
    console.log('profile. not browser')
    this.meta.addTag({name:'og:title', content:'this is the title added by the server'})
    this.meta.addTag({name:'test', content:'this is the title added by the server'})
  }

  async setProfile(){
    let slug = this.route.snapshot.queryParamMap.get('slug')
    let id = this.route.snapshot.queryParamMap.get('id')
    let expanded = this.route.snapshot.queryParamMap.get('expanded')

    let payload = null

    if (id) {
      payload = {rcl:id}
    } else {
      payload = {slug:slug}
    }

    this.profile = this.profileSignal()
    if (this.profile?.public_view) {
      this.isIframe = true;
    }

    if (this.profile.retailer) {

      if (!this.profile.public_view) {
        this.profile.echelons.map((echelon:any) => {

          let name = null
          if (this.profile.current_list) {
            name = this.profile.current_list.name
          } else {
            this.profile.retailer.name
          }
          echelon.name = echelon.name.replace("[list_name]", this.profile.current_list?.name) //Replace variables on echelon generic name
        })
      }

      if (this.profile.retailer.is_vendor) {
        this.profileType = 'supplier'
      } else {
        this.profileType = 'retailer'
      }

      if (this.profile.current_list) { //Retailer in a list
        let crumbtrail = [
          {text:'Rankings', rcl:null},
          {text:this.profile.current_list.name, rcl:this.profile.current_list.rcl},
          {text:this.profile.retailer.name, rcl:this.profile.retailer.rcl}

        ]

        // console.log('Crumbtrail')
        // console.log(crumbtrail)
        this.crumbtrailService.setCrumbtrailContent(crumbtrail)
      } else { //Retailer without a list
        let first_item = {text:'Retailers', rcl:null}

        if (this.profile.retailer.is_vendor) {
          first_item = {text:'Suppliers', rcl:null}
        }
        let crumbtrail = [
          first_item,
          {text:this.profile.retailer.name, rcl:this.profile.retailer.rcl}
        ]
        // console.log('Crumbtrail')
        // console.log(crumbtrail)
        this.crumbtrailService.setCrumbtrailContent(crumbtrail)
      }

    }
    else if (this.profile.sector) {
      this.profileType = 'sector'
    }
    else if (this.profile.region) {
      this.profileType = 'region'
    }
    else { //List without retailer
      this.profileType = 'list'
      let crumbtrail = [
        {text:'Rankings', rcl:null},
        {text:this.profile.current_list.name, rcl:this.profile.current_list.rcl}
      ]
      // console.log('Crumbtrail')
      // console.log(crumbtrail)
      this.crumbtrailService.setCrumbtrailContent(crumbtrail)

    }

    this.showdata = true

    /*
    this.retService.getProfile(payload).subscribe((response:any) => {

      this.profile = response.data
      // this.profile = this.profile.list_cluster_object.sort((a:any, b:any) => {
      //   if (a.retailers.name < b.retailers.name) {
      //     return -1;
      //   }
      //   if (a.retailers.name > b.retailers.name) {
      //     return 1;
      //   }
      //   return 0;
      // });

      //      console.log('this.profile', this.profile);
      if (response.data.retailer) {

        this.profile.echelons.map((echelon:any) => {

          let name = null
          if (this.profile.current_list) {
            name = this.profile.current_list.name
          } else {
            this.profile.retailer.name
          }
          echelon.name = echelon.name.replace("[list_name]", this.profile.current_list?.name) //Replace variables on echelon generic name
        })
        this.profileType = 'retailer'
      }
      else {

        this.profileType = 'list'
      }

      console.log('got profile: ', this.profile)
      this.showdata = true



    })*/

  }
}
